export default {
    name: 'Redemption',

    props: {
        operation: {
            type: Object,
            required: true
        }
    }
};
